import type { SVGProps } from 'react';
export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M13.85 8.13A.5.5 0 0 0 13.5 8h-7a.5.5 0 0 0-.35.13.4.4 0 0 0-.15.31q0 .18.15.32l3.5 3.1q.14.14.35.14t.35-.13l3.5-3.11a.4.4 0 0 0 .15-.32.4.4 0 0 0-.15-.3" />
  </svg>
);
